import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import {
  StyledHorizontalDivider,
  StyledMemberIdentified,
  StyledMemberWRole,
  StyledMemberWRoleSpan,
} from "../styled/styles";
import PropTypes from "prop-types";
import { isWorkspaceOwner } from "../../_utils/common";
import MemberRowRoleDD from "./MemberRowRoleDD";
import { Avatar, Box, Flex, Text } from "@chakra-ui/react";
import { blackAlpha } from "../styled/variable";
import { useTranslation } from "react-i18next";

function MemberRow(props) {
  const { t } = useTranslation(["common"]);
  const { roles } = props;
  const [member, setMember] = useState(props.member);
  const memberIdentifier = member.display_name?.trim() || member?.email;

  useEffect(() => {
    setMember({ ...props.member });
  }, [props.member]);

  const [isAuthorizeToChangeRole, setAuthorizeToChangeRole] = useState(
    props.isAuthorizeToChangeRole
  );

  useEffect(() => {
    setAuthorizeToChangeRole(props.isAuthorizeToChangeRole);
  }, [props.isAuthorizeToChangeRole]);

  return (
    <Flex direction="row" align="center" justify="space-between" my="1rem">
      <Flex direction="row" align="center">
        <Avatar
          name={memberIdentifier}
          bg={blackAlpha}
          sx={{
            div: {
              color: "gray.100",
            },
          }}
          mr="1rem"
        />

        <Flex direction="column" align="flex-start">
          <StyledMemberIdentified>
            {memberIdentifier}{" "}
            {props.isAuthenticateUser ? (
              <StyledMemberWRoleSpan>(Me)</StyledMemberWRoleSpan>
            ) : null}
            {member?.content_role && (
              <StyledMemberWRoleSpan>
                ({member?.role?.display_name})
              </StyledMemberWRoleSpan>
            )}
          </StyledMemberIdentified>
          <StyledMemberWRole>{member?.email}</StyledMemberWRole>
        </Flex>
      </Flex>

      <Box>
        {isWorkspaceOwner(member) ? (
          <Text>{t("owner")}</Text>
        ) : (
          <MemberRowRoleDD
            member={member}
            roles={roles}
            onAction={props.onAction}
            isAuthorizeToChangeRole={isAuthorizeToChangeRole}
          />
        )}
      </Box>
    </Flex>
  );
}

function OrgMembers(props) {
  const { roles } = props;
  const [orgMembers, setOrgMembers] = useState(props.members);

  const [authenticatedUserId, setAuthenticatedUserId] = useState(
    props.authenticateUser.pk
  );

  useEffect(() => {
    // TODO: fetch orgMembers
    setOrgMembers([...props.members]);
  }, [props.members]);

  useEffect(() => {
    setAuthenticatedUserId(props.authenticateUser.pk);
  }, [props.authenticateUser.pk]);

  const [isAuthorizeToChangeRole, setAuthorizeToChangeRole] = useState(
    props.isAuthorizeToChangeRole
  );

  useEffect(() => {
    setAuthorizeToChangeRole(props.isAuthorizeToChangeRole);
  }, [props.isAuthorizeToChangeRole]);

  return (
    <>
      {orgMembers.map((member, index) => {
        const isAuthenticateUser = member?.user_id === authenticatedUserId;
        return (
          <React.Fragment key={member.id}>
            <MemberRow
              member={member}
              roles={roles}
              onAction={props.onAction}
              isAuthenticateUser={isAuthenticateUser}
              isAuthorizeToChangeRole={isAuthorizeToChangeRole}
            />
            {orgMembers.length !== index + 1 && <StyledHorizontalDivider />}
          </React.Fragment>
        );
      })}
    </>
  );
}

OrgMembers.propTypes = {
  roles: PropTypes.array.isRequired,
  members: PropTypes.array.isRequired,
  rolePrefix: PropTypes.string,
  onAction: PropTypes.func.isRequired,
  isWorkspaceSettings: PropTypes.bool,
  isAuthorizeToChangeRole: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  authenticateUser: state.auth.payload.user,
});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(OrgMembers);
